var boostPFSInstantSearchConfig={search:{}};(function(){BoostPFS.inject(this),SearchInput.prototype.customizeInstantSearch=function(){var t=this.$uiMenuElement,e=this.$element,n=this.id}})();
//# sourceMappingURL=/s/files/1/0576/3992/7991/t/3/assets/boost-pfs-instant-search.js.map?v=1629654780
